<template>
  <div  class="text">
    <h1>{{ $t('driver_onboarding.profile.contract.contract_is_ready_title') }}</h1>
    <span>{{ $t('driver_onboarding.profile.contract.contract_is_ready_desc') }}</span>
    <br />
    <a target="_blank" class="button" :disabled="loading" :href="contractLink">{{ $t('driver_onboarding.profile.contract.contract_is_ready_button') }}</a>
    <br />
    <p v-if="!loading" class="reload-note">Sau khi ký xong vui lòng bấm 
        <img src="/img/icons/reload.svg" alt="">
        <a @click="reload">Tải lại trang</a> để cập nhật trạng thái hợp đồng
    </p>
    <div v-else class="reload-note is-flex">
        <p> {{ $t('driver_onboarding.profile.contract.contract_is_ready_loading') }}</p>
        <progress value="0" max="5" id="progressBar"></progress>
    </div>

    </div>
</template>

<script>
import {mapGetters} from "vuex";
import { removeItemStorage } from "@/plugins/utils"


export default {
    data() {
        return {
            isShowReload : true,
            loading: false,
            countTimer : 5
        }
    },
    computed: {
        ...mapGetters(['supplierToken', 'supplierProfile']),
        contractLink() {
            const profile = this.supplierProfile
            return profile && profile.extra && profile.extra.contract_signing_url
        }
    },
    methods: {
        reload() {
            this.loading = true
            let timeleft = this.countTimer
            var downloadTimer = setInterval( () => {
                if(timeleft <= 0){
                    clearInterval(downloadTimer);
                    this.$store.dispatch("getProfile", this.supplierToken).then(() => {
                        this.loading = false
                    }).catch(error => {
                        this.loading = false
                        if(error.status === 404) {
                            if(error.data.title === 'Supplier not found'){
                                this.$buefy.notification.open({
                                message: this.$t("driver_onboarding.auth.supplier_not_found"),
                                type: "is-danger",
                                duration: 3000,
                                position: "is-bottom"
                                });
                            }else{
                                this.$buefy.notification.open({
                                    message: this.$t("driver_onboarding.auth.token_expire"),
                                    type: "is-danger",
                                    duration: 3000,
                                    position: "is-bottom"
                                });
                                this.$store.dispatch('logout', this.supplierToken)
                                    .then(response => {
                                        if(response && response.status === 200) {
                                        this.$deleteCookie(this.$constants.COOKIE_SUPPLIER_TOKEN)
                                        this.$deleteCookie('timer');
                                        removeItemStorage(this.$constants.LOCAL_STORAGE_SUPPLIER)

                                        this.$router.push({name : 'signup'})
                                        this.$buefy.notification.open({
                                            message: this.$t("driver_onboarding.logout_success"),
                                            type: "is-success",
                                            duration: 3000,
                                            position: "is-bottom"
                                        });
                                        }
                                    }).catch(error => {
                                        console.log(error)
                                    })
                            }
                        }
                    })
                }
                document.getElementById("progressBar").value = 5 - timeleft;
                timeleft -= 1;
            }, 1000);
        },
    },
    beforeMount () {
        this.reload()
    }
}
</script>

<style>

</style>